import React, { useEffect, useState } from "react";
import config from "appConfig";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal, Select, Table } from "antd";
import styles from "./manageCartPage.scss";
import { CartSearchForm } from "../CartSearchForm";
import { IndexPagination } from "../../../components/IndexPagination";
import {
  updateCart,
  getCarts,
  selectCarts
} from "./cart.ducks";
import PageTitle from "../PageTitle";
import { formatDate } from "../../../services";
import { selectUserInfo } from "../../Auth/auth.ducks";
import { PaymentMethodText, ShoppingCartStatus, ShoppingCartStatusText, UserRole } from "../../../models";

const itemPerPage = 20;

const ManageCartPage = props => {
  const {
    carts,
  } = props;

  const [loading, setLoading] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState({});
  const tableText = { emptyText: "Nema podataka" };


  const columns: any = [
    {
      title: "Naziv usluge",
      dataIndex: "name",
      key: "name",
      width: 80,
    },
    {
      title: "Cijena",
      dataIndex: "price",
      key: "price",
      width: 50,
      render: value => `${value}${config.currencySymbol}` 
    },
    {
      title: "Poziv na broj",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
      width: 80,
    },
    {
      title: "Korisničko ime",
      dataIndex: "userName",
      key: "userName",
      width: 100,
      render: (text, record) => (
        <Link className="profile-link" title={text} to={`/admin/user/profile/${record.userId}`}>
          {text}
        </Link>
      )
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 80,
    },
    {
      title: "Datum",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 60,
      render: value => formatDate(value, config.fullTimeFormat),
    },
    {
      title: "Opcija plaćanja",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      width: 110,
      render: value => PaymentMethodText.find(p => p.value === value).name
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 115,
      // render select with on change event, current value is selected
      render: (value, record) => <Select 
        value={value}
        style={{ width: 180 }} 
        onChange={val => handleStatusChange(
          val,
          record
        )}
      >
        {ShoppingCartStatusText.map(s => (
          s.value !== ShoppingCartStatus.awaitingCreditCardPayment &&
          <Select.Option
            key={s.value}
            value={s.value}
            disabled={
              (
                value == ShoppingCartStatus.completed && 
                s.value !== ShoppingCartStatus.refunded
              ) || value === ShoppingCartStatus.refunded
            }
          >
            {s.name}
          </Select.Option>
        ))}
      </Select>
    },
  ];

  useEffect(() => {
    search();
  }, []);

  const handleStatusChange = (value, record) => {
    Modal.confirm({
      title: 'Jeste li sigurni da želite promijeniti status ove transakcije u "{0}" ?'.replace("{0}", ShoppingCartStatusText.find(s => s.value === value).name),
      // @ts-ignore
      centered: true,
      iconType: "NaN",
      onOk: () => {
        props.updateCart(record.id, { status: value }, (cart) => {
          if (cart) {
            search(searchCriteria);
          }
        });
      },

      onCancel: () => {
        search({searchCriteria});
      }
    });
  }

  const handleSearch = searchCriteria => {
    setSearchCriteria(searchCriteria);
    search(searchCriteria);
  };

  const handlePageChange = page => {
    search(searchCriteria, page);
  };

  function search(searchCriteria = {}, page = 1) {
    setLoading(true);

    // Dates arrive already normalized to a YYYY-MM-DD string from
    // CartSearchForm — no further TZ conversion here (previous .utc().format()
    // shifted the range and included transactions from the next day).
    props.getCarts({ ...searchCriteria, page, itemPerPage }, () => setLoading(false));
  }

  return (
    <React.Fragment>
      <PageTitle title={"Upravljaj transakcijama"} />
      {/* 
      // @ts-ignore */}
      <CartSearchForm onSubmit={handleSearch} />
      <div className={styles.tableWrapper}>
        { carts && carts.totalPrice ? 
          <p className={styles.priceSum}>
            <span>{`${"Ukupna cijena"}: `}</span>
            {`${carts.totalPrice} €`}
          </p>
          : null
        }
        <Table
          loading={loading}
          rowKey="username"
          bordered
          dataSource={carts ? carts.data : []}
          columns={columns}
          pagination={false}
          locale={tableText}
          scroll={{ x: "100%" }}
          className={`admin-table ${styles.table}`}
        />
        {carts ? (
          <IndexPagination
            total={carts.count}
            page={carts.page}
            itemPerPage={itemPerPage}
            onPageChange={handlePageChange}
          />
        ) : null}
      </div>


    </React.Fragment>
  );
};

ManageCartPage.defaultProps = {
  carts: null,
};

export default connect(
  state => ({
    carts: selectCarts(state),
    currentUser: selectUserInfo(state),
  }),
  {
    getCarts,
    updateCart,
  }
)(ManageCartPage);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageCartPage/ManageCartPage.tsx